import Truong from "./Truong"
export default Truong